import { LoadableUserProfile } from "features";
import React from "react";
import { Breadcrumb } from "shared/ui/components";

export default function UserProfilePage() {
  return (
    <>
      <Breadcrumb />
      <LoadableUserProfile />
    </>
  );
}
